import { Injectable,Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { NUMBER_FORMAT_REGEXP } from '@angular/common/src/i18n/format_number';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class GridColumns {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
  visible:boolean;
};

export class BranchAppGrid{
  CourseBranchID:number;
  BranchName:string;
  BranchID:number;
  CourseID:number;
  BranchSequenceNo:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
}

export class GridColumnsBranchInfo {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
};

let gridColumnsBranch: GridColumnsBranchInfo[] = [

  {
    "caption": 'BranchName',
    "dataField": "BranchName",
    "width": 200,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true
  },
  {
    "caption": 'Branch Sequence No',
    "dataField": "BranchSequenceNo",
    "width": 200,
    "dataType": "number",
    "cssClass": "",
    "allowSorting": true
  }
]
let gridColumnsAdmissionCategory: GridColumns[] = [

  {
    "caption": 'Course',
    "dataField": "CourseName",
    "width": 400,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  },/* {
    "caption": 'Branch',
    "dataField": "BranchName",
    "width": 340,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true
  }, */
  {
    "caption": 'Admission Category',
    "dataField": "AdmissionCategory",
    "width": 300,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Admission Category',
    "dataField": "EntranceExamFlag",
    "width": 200,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":false
  },
  {
    "caption": 'Other than Home University Quota',
    "dataField": "OtherUniversityQuota",
    "width": 300,
    "dataType": "number",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  } ,
  {
    "caption": 'Outside University Mark Exemption',
    "dataField": "OutSideStudentMarkExemption",
    "width": 300,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":false
  } 
]


export class Course {
  CourseID:number;
  Faculty: string;
  FacultyID:number;
  CourseName: string;
  CourseNameInDevnagri:string;
  CourseShortName: string;
  CourseCode: string;
  CourseSequenceNo:number;
  CourseTypeID:number;
  ProgramTypeID:number;
  CourseLevelID:number;
  HallTicketDesgID:number;
  MarkSheetDesgID:number;
  TrfSignID:number;
  MigSignID:number;
  PassSignID:number;
  SFCPasssignID:number;
  RevalDesgid:number;
 
  GradePrint:string;
  BranchApplicableFlag:string;
  RegToDistTransfer:string;
  DistToRegtTransfer:string;
  DateDeclarationApplicableFlag:string
  GRCLtype:string
  NoofSub:string;
  EntranceExamFlag:string;
  EntranceExamWaitage:number;
  QalifyingExamWaitage:number;
  OtherUniversityQuota:number
  OutSideStudentMarkExemption:string;
  DegreeWaitage:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
  chkGradePrint:boolean;
  chkBranchApplicableFlag:boolean;
  chkRegToDistTransfer:boolean;
  chkDistToRegtTransfer:boolean;
  chkDateDeclarationApplicableFlag:boolean;
  chkGRCLtype:boolean;
  chkEntranceExamFlag:boolean;
  Designation:string;
  
  DesignationID:number;
 /*  HallTicketDesgNm:string;
  MarkSheetDesgNm:string;
  SFCPasssignNm:string;
  RevalDesgNm:string;
  TrfSignNm:string;
  MigSignNm:string;
  PassSignNm:string; */


}

let gridColumns: GridColumns[] = [
    {
   "caption": 'Faculty',
   "dataField": "FacultyName",
   "width": 200,
   "dataType": "string",
   "cssClass": "",
  "allowSorting": true,
  "visible":true
 },

{
  "caption": 'Program',
  "dataField": "CourseName",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
{
  "caption": 'Short Name',
  "dataField": "CourseShortName",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
 {
  "caption": 'Program Code',
  "dataField": "CourseCode",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
{
  "caption": 'Course Sequence No',
  "dataField": "CourseSequenceNo",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},

{
  "caption": 'Course Type',
  "dataField": "CourseTypeName",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
{
  "caption": 'Program Level',
  "dataField": "CourseLevel",
  "width":150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
{
  "caption": 'Program Type',
  "dataField": "ProgramType",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
}/*,
{
  "caption": 'HallTicket Desg',
  "dataField": "HallTickDesg",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'MarkSheet Desg',
  "dataField": "MarkSheetDesg",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Transfer Desg',
  "dataField": "TransferDesg",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Migration Desg',
  "dataField": "MigrationDesg",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Passing Desg',
  "dataField": "PassingDesg",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'SFC Passing Desg',
  "dataField": "SFCPassingDesgg",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Reval Desg',
  "dataField": "RevalDesg",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Print Grade',
  "dataField": "PrintGrade",
  "width": 200,
  "dataType": "boolean",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Branch Application',
  "dataField": "BranchApp",
  "width": 200,
  "dataType": "boolean",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Medium',
  "dataField": "Medium",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},

{
  "caption": 'Regular To Distance',
  "dataField": "RegToDist",
  "width": 200,
  "dataType": "boolean",
  "cssClass": "",
  "allowSorting": true
} */

];
export class AdmissionCategory 
{
  AdmissionTypeID:number;
  AdmissionTypeText:string;
}
/* let admissioncategory: AdmissionCategory[] = [
  {
    EntranceExamFlag:0,
  AdmissionCategoryName:"Direct Admission"
  },
  {
    EntranceExamFlag:1,
  AdmissionCategoryName:"Direct Admission With Allotment Letter"
  },
  {
    EntranceExamFlag:2,
  AdmissionCategoryName:"On Merit"
  },
  {
    EntranceExamFlag:3,
  AdmissionCategoryName:"On CET"
  },
  {
    EntranceExamFlag:4,
  AdmissionCategoryName:"On Merit With CET"
  }
];
 */

export class AdmissionCategoryData 
{
  CourseID:number;
  EntranceExamFlag:number;
  OtherUniversityQuota:number;
  OutSideStudentMarkExemption:string;
  BranchID:number;
  AllBranchApplicableForCET:number;
  AdmissionCategory:number; 
  CourseBranchID:number;
  UpdatedLoginID:number; 
}
let admissionCategoryData: AdmissionCategoryData[]=[{ 
  "CourseID":null,
"EntranceExamFlag":null,
"AdmissionCategory":null,
"OtherUniversityQuota":null,
"OutSideStudentMarkExemption":null,
"BranchID":null,
"AllBranchApplicableForCET":null,
"CourseBranchID":null,
"UpdatedLoginID":null
}];


@Injectable( {  
  providedIn: 'root'  
})
@Component({
  providers: [DataAccessService]
})

export class CourseService {


  constructor(
    private dataService: DataAccessService) 
    {

  }
  public CourseData: Course;
  public dataSourceBranch: BranchAppGrid;
  public errormsg;
  public successmsg;
  

  public getAllCourse() {
    
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseList?CourseID=0'; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()

  }
  public getCourseDataWithBranch() {
    
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetCourseDataWithBranchAndQuota?'; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()

  }
 /*  public GetCourseForEntrance() {
    
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetCourseForEntrance'; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()

  } */
  /* public getAllStateByObject(data){
    this.dataService.setMethodName = 'GetBasicStateList'; // setting method name from API controller.
    return this.dataService.getAllWithObject<Course[]>(data) 
  } */ 
  public getCourseByID(courseid) {debugger
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseList?CourseID='+ courseid +''; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()
  } 

  public save(data) {
    
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'PostInsertBasicCourse'; // setting method name from API controller.
    return this.dataService.add<Course[]>(data) 
  }
  public update(data) {
    
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'PostBasicCourse'; // setting method name from API controller.
    return this.dataService.add<Course[]>(data)
  }
  public delete(data) {
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'PostDeleteBasicCourse'; // setting method name from API controller.
    return this.dataService.delete<Course[]>(data)
  }
  public saveAdmissionCategory(data)
  {debugger
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'PostUpdateBasicCourseEntExamFlagOtherUniQuotaOutSiteStudMrkExpt?CourseID=' + data.CourseID + '&EntranceExamFlag=' + data.EntranceExamFlag + '&OtherUniversityQuota=' + data.OtherUniversityQuota + '&OutSideStudentMarkExemption=' + data.OutSideStudentMarkExemption+ '&UpdatedLoginID=' + data.UpdatedLoginID; // setting method name from API controller.
    return this.dataService.add<Course[]>(data) 
  }
  public saveCourseBranch(data) {
    
    this.dataService.setControllerName = '/BasicCourseBranch/';
    this.dataService.setMethodName = 'PostInsertBasicCourseBranch'; // setting method name from API controller.
    return this.dataService.add<BranchAppGrid[]>(data) 
  }

  public getAllCourseBranch() {
    
    this.dataService.setControllerName = '/BasicCourseBranch/';
    this.dataService.setMethodName = 'GetBasicCourseBranchList?CourseID=0'; // setting method name from API controller.
    return this.dataService.getAll<BranchAppGrid[]>()

  }
  /* public getAllStateByObject(data){
    this.dataService.setMethodName = 'GetBasicStateList'; // setting method name from API controller.
    return this.dataService.getAllWithObject<Course[]>(data) 
  } */
  public getCourseBranchByID(id) {

    this.dataService.setControllerName = '/BasicCourseBranch/';
    this.dataService.setMethodName = 'GetBasicCourseBranchList';
    this.dataService
      .getSingle<BranchAppGrid>('?BranchID='+id)    
      .subscribe((data: BranchAppGrid) => this.dataSourceBranch = data,
        error => () => {
        },
        () => {
              return this.CourseData;
        });
  }

  public getCourseBranchByCourseeID(id) {
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseBranchByCourseID?CourseID='+ id +''; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()
  }

  public GetBasicCourseBranchByCourseIDPortal(id) {
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseBranchByCourseIDPortal?CourseID='+ id +''; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()
  }

  public GetBasicCourseListPortal() {
    
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseListPortal?CourseID=0'; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()

  }
  public GetBasicCourseListPortalNEW(CourseType) {
    
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseListPortalNEW?CourseID=0&CourseType='+CourseType+''; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()

  }
  getGridColumns() {
    return gridColumns;
  }
  /* getDes1()
  {
    return this.CourseData.Designation
  } */
 getGridColumnsBarnchInfo() {
    return gridColumnsBranch;
  } 
  /* getSelectedBranch(){
    return branchInfo;
      } */
      /* getAdmissionCategory()
      {
        return admissioncategory;
      } */
      public getAdmissionCategory() {
    
        this.dataService.setControllerName = '/BasicCourse/';
        this.dataService.setMethodName = 'GetAdmissionTypes'; // setting method name from API controller.
        return this.dataService.getAll<Course[]>()
    
      }
      getAdmissionCategoryData()
      {
        return admissionCategoryData;
      }
      getgridColumnsAdmissionCategory()
      {
        return gridColumnsAdmissionCategory;
      }

}